import { render, staticRenderFns } from "./FormEnrolment.vue?vue&type=template&id=3a1c9cbc&scoped=true&"
import script from "./FormEnrolment.vue?vue&type=script&lang=js&"
export * from "./FormEnrolment.vue?vue&type=script&lang=js&"
import style0 from "./FormEnrolment.vue?vue&type=style&index=0&id=3a1c9cbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c9cbc",
  null
  
)

export default component.exports